/**
 * AI 어시스턴트(QBase 플랫폼 공통 서비스) 접속 설정.
 *
 * 서비스는 OpenFlow 백엔드가 아니라 QBase 쪽 공통 서비스다(qbase/assistant-service).
 * 개발에서는 setupProxy 가 /assistant 를 그 서비스로 넘겨 주므로 같은 오리진으로 보이고,
 * 운영도 리버스 프록시로 같은 오리진에 두는 것을 기본으로 한다 — 세션 쿠키가 그대로 붙는다.
 *
 * 스탠드얼론(로컬 모드)은 기본으로 끈다. 무설치판은 REACT_APP_ASSISTANT=on 으로 빌드해 코드를 넣고
 * (scripts/portable/pack-portable.ps1), 실제로 쓸지는 **실행 중에** 서버가 정한다 — 내부망이면 감춘다
 * (hooks/useAssistantEnabled · backend routers/assistant_proxy). 화면은 이 값을 직접 보지 말고 그 훅을 쓴다.
 */
import { IS_LOCAL } from './mode';

const raw = process.env.REACT_APP_ASSISTANT_URL;

/** 어시스턴트 API 앞부분. 빈 문자열이면 같은 오리진(상대경로). */
export const ASSISTANT_API: string =
  raw !== undefined && raw.trim() !== '' ? raw.trim().replace(/\/+$/, '') : '';

/** 이 테넌트 id — 서비스의 tenants/openflow.json 과 같아야 한다. */
export const ASSISTANT_TENANT = 'openflow';

const forced = (process.env.REACT_APP_ASSISTANT || '').trim().toLowerCase();

export const ASSISTANT_ENABLED: boolean =
  forced === 'on' ? true : forced === 'off' ? false : !IS_LOCAL;
